import angular from 'angular';

module.exports = angular.module('common.directives.confirm', [])
.directive('ocConfirm', function() {
  return {
    restrict: 'A',
    priority: -1,
    link: function(scope, elem, attrs) {
      elem.on('click', function(e) {
        if (attrs.ocConfirm && !confirm(attrs.ocConfirm)) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/confirm.js
 **/